/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'shared';
const componentName = 'avi-dropdown';
const prefix = `${moduleName}.${componentName}`;

export const selectPlaceholder = `${prefix}.selectPlaceholder`;
export const clearAllLabel = `${prefix}.clearAllLabel`;
export const notConfiguredPlaceholder = `${prefix}.notConfiguredPlaceholder`;

export const ENGLISH = {
    [selectPlaceholder]: 'Select',
    [clearAllLabel]: 'Clear all',
    [notConfiguredPlaceholder]: 'Not Configured',
};
